// Description : Mail tab for Callout page

import * as React from "react";
// import axios from '../../../axios/Axios';
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../redux/features/appSlice";
import { Button } from "react-bootstrap";
import {
  Box,
  Modal,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material/";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import { CloseSharp } from "@mui/icons-material";
import { FormControl } from "@mui/material";
import Axios from "../../../axios/Axios";
import { LoadingButton } from "@mui/lab";
import { useEffect } from "react";
import axios from "axios";
import { DialogTitle } from "@mui/material";
import { DialogContentText } from "@mui/material";

// Stylings for the Modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: "98%",
  bgcolor: "background.paper",
  border: "2px solid #CED4DA",
  borderRadius: "5px",
  boxShadow: 24,
  padding: "20px",
  overflowY: "scroll",
};

export default function MailModal(props) {
  const dispatch = useDispatch();
  const { templates } = useSelector((data) => data);
  const { user } = useSelector((data) => data.user);

  const [open, setOpen] = React.useState(false);
  const [calloutType, setCalloutType] = React.useState("mail");
  const [senderMailIds, setSenderMailIds] = React.useState([]);
  const [toMail, setToMail] = React.useState("");
  const [suggestMail, setSuggestMail] = React.useState([]);
  // console.log(suggestMail);
  const [whatsappData, setWhatsappData] = React.useState({
    emails: "Whatsapp contact",
    category: "",
    message: "",
    created_by: sessionStorage.getItem("username"),
  });
  const [whatsappDataError, setWhatsappDataError] = React.useState({
    emailsError: false,
    calloutError: false,
    messageError: false,
  });

  const [mailData, setMailData] = React.useState({
    from_id: "letsteachenglish.act@gmail.com",
    calloutType: calloutType,
    subject: "",
    message: "",
    created_by: sessionStorage.getItem("username"),
    category: "",
  });
  const [error, setError] = React.useState({
    toError: false,
    categoryError: false,
    messageError: false,
    subjectError: false,
  });
  const [loading, setLoading] = React.useState(false);
  const [unRegisterEmail, setUnRegisterEmail] = React.useState(false);
  const [unRegisterEmailList, setUnRegisterEmailList] = React.useState([]);
  const [sentUnRegisterEmail, setSentUnRegisterEmail] = React.useState(false);

  const mailCalloutMessages = templates
    .filter(
      (template) =>
        template.mail_type === "teacher_callout_mail_template" ||
        template.mail_type === "student_callout_mail_template"
    )
    .map((template) => {
      if (template.mail_type === "teacher_callout_mail_template") {
        return { ...template, callout_type: "teachers" };
      }
      // fallback is safe due to filter
      return { ...template, callout_type: "students" };
    });

  const whatsappCalloutMessages = templates
    .filter(
      (template) =>
        template.mail_type === "teacher_callout_whatsapp_template" ||
        template.mail_type === "student_callout_whatsapp_template"
    )
    .map((template) => ({
      ...template,
      callout_type:
        template.mail_type === "teacher_callout_whatsapp_template"
          ? "teachers"
          : "students",
    }));

  // console.log(error);
  // console.log(whatsappCalloutMessages);

  // console.log(sentUnRegisterEmail, 'sentUnRegisterEmail');
  //POST Request : Send callout email
  async function sendCalloutEmail(event) {
    event.preventDefault();

    if (
      (toMail === "" && senderMailIds.length === 0) ||
      mailData.subject === "" ||
      mailData.category === "" ||
      mailData.message === ""
    ) {
      if (mailData.category === "") {
        setError((prev) => ({ ...prev, categoryError: true }));
      }

      if (mailData.subject === "") {
        setError((prev) => ({ ...prev, subjectError: true }));
      }

      if (mailData.message === "") {
        setError((prev) => ({ ...prev, messageError: true }));
      }

      return dispatch(
        showSnackbar({
          message:
            "There are one or more input fields are empty, Please enter a valid information",
          severity: "error",
        })
      );
    }

    try {
      setLoading(true);
      const postData =
        senderMailIds.length > 0
          ? { ...mailData, mail_list: senderMailIds }
          : { ...mailData, mail_list: [{ emails: toMail }] };

      const postRequiredData =
        senderMailIds.length > 0
          ? { emails: senderMailIds }
          : { emails: [{ emails: toMail }] };
      if (!sentUnRegisterEmail) {
        const requiredOptions = {
          method: "post",
          url: "/announcement/verifyEmails",
          auth: false,
          data: postRequiredData,
        };

        const requiredResponse = await Axios(
          requiredOptions.method,
          requiredOptions.url,
          requiredOptions.auth,
          requiredOptions.data
        );
        // console.log(requiredResponse);

        if (
          requiredResponse.status === 200 &&
          requiredResponse.data.hasUnRegisteredEmails === true
        ) {
          // console.log("unregistered");
          setLoading(false);
          setUnRegisterEmail(true);
          setUnRegisterEmailList(requiredResponse.data.unRegisteredEmils);
          setSentUnRegisterEmail(true);
        } else if (
          requiredResponse.status === 200 &&
          requiredResponse.data.hasUnRegisteredEmails === false
        ) {
          // setLoading(false);
          setSentUnRegisterEmail(true);
          await sendCalloutEmailFunction(postData);
        } else if (sentUnRegisterEmail) {
          await sendCalloutEmailFunction(postData);
        }
      } else if (sentUnRegisterEmail) {
        await sendCalloutEmailFunction(postData);
      }
    } catch (err) {
      console.log(err);
      dispatch(
        showSnackbar({
          message: "Failed sending callout!",
          severity: "error",
        })
      );
    }
  }
  // async function sendCalloutEmailFunction(postData) {
  //   const options = {
  //     method: "post",
  //     url: "/callout/createcallout",
  //     auth: false,
  //     data: postData,
  //     headers:{
  //       autho
  //     }
  //     token: user.access_token,
  //   };

  //   const response = await Axios(
  //     options.method,
  //     options.url,
  //     options.auth,
  //     options.data
  //   );
 
  //   if (response.status === 200) {
  //     props.onCloseCallback();
  //     setOpen(false);
  //     setMailData((prev) => ({
  //       ...prev,
  //       subject: "",
  //       message: "",
  //       category: "",
  //     }));
  //     setSenderMailIds([]);
  //     setToMail("");
  //     dispatch(
  //       showSnackbar({
  //         message: "Callout sent successfully",
  //         severity: "success",
  //       })
  //     );
  //     setLoading(false);
  //     setSentUnRegisterEmail(false);
  //     // window.location.reload();
  //   }
  // }

async function sendCalloutEmailFunction(postData) {
  try {
    setLoading(true);

    const response = await axios.post(
      "/callout/createcallout",
      postData,
      {
        headers: {
          Authorization: `${user.access_token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      props.onCloseCallback();
      setOpen(false);
      setMailData((prev) => ({
        ...prev,
        subject: "",
        message: "",
        category: "",
      }));
      setSenderMailIds([]);
      setToMail("");
      dispatch(
        showSnackbar({
          message: "Callout sent successfully",
          severity: "success",
        })
      );
      setLoading(false);
      setSentUnRegisterEmail(false);
    }
  } catch (error) {
    console.error("Error sending callout:", error);
    setLoading(false);
    dispatch(
      showSnackbar({
        message: "Failed to send callout",
        severity: "error",
      })
    );
  }
}


  // Post Method: Send callout via whatsapp
  async function sendCalloutViaWhatsapp() {
    if (whatsappData.category === "" || whatsappData.message === "") {
      // whatsappData.emails === "" ||
      // if(whatsappData.emails === "" || whatsappData.emails.length <  10){
      //   setWhatsappDataError(prev => ({...prev, emailsError: true}))
      // }

      if (whatsappData.category === "") {
        setWhatsappDataError((prev) => ({ ...prev, calloutError: true }));
      }

      if (whatsappData.message === "") {
        setWhatsappDataError((prev) => ({ ...prev, messageError: true }));
      }

      return dispatch(
        showSnackbar({
          message:
            "There are one or more input fields are empty, Please enter a valid information",
          severity: "error",
        })
      );
    }
    try {
      setLoading(true);
      const response = await Axios(
        "post",
        "callout/createcallout/whatsapp",
        true,
        whatsappData
      );
      if (response.status === 200) {
        window.open(
          `https://web.whatsapp.com/send?text=${whatsappData.message}`
        );
        // window.location.reload();
        props.onCloseCallback();
        dispatch(
          showSnackbar({
            message: "Whatsapp callout information saved successfully",
            severity: "success",
          })
        );
        setOpen(false);
        setWhatsappData({
          emails: "",
          category: "",
          message: "",
          created_by: sessionStorage.getItem("username"),
        });
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      dispatch(
        showSnackbar({
          message: "Failed saving whatsapp callout!",
          severity: "error",
        })
      );
    }
  }

  // GET Request : email suggestion in to field

  useEffect(() => {
    const controller = axios.CancelToken.source();
    // console.log(controller);
    const fetchData = async () => {
      try {
        const options = {
          method: "post",
          url: "/announcement/getEmails",
          auth: true,
          data: { email: toMail },
          token: { cancelToken: controller.token },
        };
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token
        );
        if (response.status === 200) {
          setSuggestMail(response.data);
        }
        // console.log(response);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      }
    };

    if (toMail) {
      fetchData();
    }

    // for cleanup
    return () => {
      controller.cancel();
    };
  }, [toMail]);

  function UnRegisterEmails({ open, onClose, setSentUnRegisterEmail }) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "scroll" }}
      >
        <DialogTitle sx={{ color: "red" }} id="alert-dialog-title">
          {"WARNING !"}
        </DialogTitle>
        <DialogContent
          dividers="true"
          sx={{
            overflowY: "scroll",
            width: "420px", // Set your desired width
            height: "150px", // Set your desired height
          }}
        >
          <DialogContentText id="alert-dialog-description">
            <Typography sx={{ paddingBottom: "10px" }}>
              Do you want to process the unregister email IDs?
            </Typography>
            <Typography gutterBottom>
              {unRegisterEmailList.map((mailList) => {
                return (
                  <Chip
                    key={mailList}
                    label={mailList}
                    size="small"
                    color="primary"
                  />
                );
              })}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions dividers="true">
          <Button
            onClick={(e) => {
              onClose();
              setSentUnRegisterEmail(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={(event) => {
              setUnRegisterEmail(false);
              sendCalloutEmail(event);
              setSentUnRegisterEmail(false);
            }}
            autoFocus
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  // module close function

  const closeModule = () => {
    // window.location.reload();
    setOpen(false);
    setLoading(false);
    setSenderMailIds([]);
    setToMail("");
    setMailData((prev) => ({
      ...prev,
      subject: "",
      message: "",
      category: "",
    }));
    setWhatsappData({
      emails: "",
      category: "",
      message: "",
      created_by: sessionStorage.getItem("username"),
    });
    setError({
      toError: false,
      categoryError: false,
      messageError: false,
      subjectError: false,
    });
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>Make Callout</Button>
      <Modal
        open={open}
        onClose={() => closeModule()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "scroll" }}
      >
        <Box sx={style}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Make Callout
            </Typography>
            <IconButton onClick={() => closeModule()}>
              <CloseSharp />
            </IconButton>
          </Stack>

          <FormControl>
            <Typography>Callout type :</Typography>
            <RadioGroup
              defaultValue="mail"
              sx={{ display: "inline" }}
              value={calloutType}
              onChange={(e) => {
                setCalloutType(e.target.value);
                setMailData((prev) => ({ ...prev, category: "", message: "" }));
              }}
            >
              <FormControlLabel value="mail" control={<Radio />} label="Mail" />
              <FormControlLabel
                value="whatsapp"
                control={<Radio />}
                label="Whatsapp"
              />
            </RadioGroup>
          </FormControl>

          {calloutType === "mail" && (
            <Stack margin="10px" spacing={3} direction="column">
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                type="text"
                variant="outlined"
                size="small"
                color="primary"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">From : </InputAdornment>
                  ),
                }}
                value={mailData.from_id}
                disabled
              />
              <Box
                className="mail-chips"
                sx={
                  senderMailIds.length === 0
                    ? { display: "none" }
                    : { display: "flex" }
                }
              >
                {senderMailIds.map((mailId) => {
                  return (
                    <Chip
                      key={mailId.emails}
                      label={mailId.emails}
                      size="small"
                      color="primary"
                      onDelete={() => {
                        setSenderMailIds((toMails) =>
                          toMails.filter(
                            (mail) => mail.emails !== mailId.emails
                          )
                        );
                      }}
                    />
                  );
                })}
              </Box>
              {senderMailIds.length === 5 && (
                <Typography
                  variant="subtitle1"
                  color="red"
                  fontSize="12px"
                  component="p"
                >
                  Sender's Mail IDs limit has exceeded
                </Typography>
              )}
              <TextField
                sx={{ "&legend": { display: "none" }, "&fieldset": { top: 0 } }}
                type="text"
                variant="outlined"
                size="small"
                color="primary"
                error={error.toError}
                value={toMail}
                helperText={error.toError && "Please Enter a valid Email ID"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">To : </InputAdornment>
                  ),
                }}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  if (inputValue) {
                    if (
                      /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/.test(event.target.value)
                    ) {
                      setError((prevState) => ({
                        ...prevState,
                        toError: true,
                      }));
                    } else {
                      console.log(event.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        toError: false,
                      }));
                    }
                    setToMail(inputValue);
                  } else {
                    console.log(inputValue);
                    setError((prevState) => ({ ...prevState, toError: false }));
                    setToMail(inputValue);
                  }
                }}
                onKeyPress={(event) => {
                  if (
                    !error.toError &&
                    event.key === "Enter" &&
                    senderMailIds.length < 5
                  ) {
                    setSenderMailIds((prevState) => {
                      return [...prevState, { emails: toMail }];
                    });
                    setToMail("");
                  }
                }}
              />
              <Box
                className="suggestions"
                sx={toMail !== "" ? { display: "flex" } : { display: "none" }}
              >
                <Typography variant="caption" color="textSecondary">
                  Suggestions:
                </Typography>
                <div className="suggestionsMail">
                  {suggestMail.map((suggestion) => (
                    <Chip
                      key={suggestion.email}
                      label={suggestion.email}
                      onClick={() => {
                        setSenderMailIds((prevState) => {
                          return [...prevState, { emails: suggestion.email }];
                        });
                        setSuggestMail([]);
                        setError((prevState) => ({
                          ...prevState,
                          toError: false,
                        }));
                        setToMail("");
                      }}
                      sx={{ cursor: "pointer", marginY: "2px" }}
                    />
                  ))}
                </div>
              </Box>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                type="text"
                variant="outlined"
                size="small"
                color="primary"
                name="subject"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">Subject : </InputAdornment>
                  ),
                }}
                error={error.subjectError}
                helperText={
                  error.subjectError &&
                  "Please enter valid subject before sending callout"
                }
                value={mailData.subject}
                onChange={(event) => {
                  setError((prev) => ({ ...prev, subjectError: false }));
                  setMailData((prevState) => ({
                    ...prevState,
                    subject: event.target.value,
                  }));
                }}
              />

              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                size="small"
                name="category"
                select
                fullWidth
                helperText={
                  !mailData.category &&
                  "Please specify whom this callout is for"
                }
                error={!mailData.category && error.categoryError}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      Callout for :{" "}
                    </InputAdornment>
                  ),
                }}
                value={mailData.category}
                onChange={(event) => {
                  mailCalloutMessages.map((callout) => {
                    return setMailData((prevState) => {
                      return callout.callout_type === event.target.value
                        ? {
                            ...prevState,
                            message: `${callout.header}\n${callout.message}\n${callout.footer}`,
                          }
                        : prevState;
                    });
                  });

                  setError((prevState) => {
                    return {
                      ...prevState,
                      categoryError: false,
                      messageError: false,
                    };
                  });
                  setMailData((prevState) => {
                    return { ...prevState, category: event.target.value };
                  });
                }}
              >
                <MenuItem value="teachers">Teachers</MenuItem>
                <MenuItem value="students">Students</MenuItem>
              </TextField>

              <Box>
                <Box className="callout-content-tools">
                  <Tooltip title="Clear">
                    <IconButton
                      onClick={() =>
                        setMailData((prevState) => {
                          return { ...prevState, message: "" };
                        })
                      }
                    >
                      <ClearAllIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Copy">
                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(mailData.message);
                        dispatch(
                          showSnackbar({
                            message: "Text Copied!",
                            severity: "success",
                          })
                        );
                      }}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  fullWidth
                  placeholder="Type here..."
                  variant="outlined"
                  size="small"
                  color="primary"
                  multiline
                  rows={5}
                  error={error.messageError}
                  helperText={
                    error.messageError && "Please enter callout message"
                  }
                  value={mailData.message}
                  onChange={(event) => {
                    setError((prev) => ({ ...prev, messageError: false }));
                    setMailData((prevState) => {
                      return { ...prevState, message: event.target.value };
                    });
                  }}
                />
              </Box>
              <LoadingButton
                type="button"
                variant="contained"
                loading={loading}
                onClick={(event) => {
                  sendCalloutEmail(event);
                }}
              >
                Send
              </LoadingButton>
            </Stack>
          )}

          {calloutType === "whatsapp" && (
            <Stack margin="10px" spacing={3} direction="column">
              {/* <TextField
              name="emails"
              size='small'
              label="Whatsapp number or Group link"
              fullWidth
              value={whatsappData.emails}
              error={whatsappDataError.emailsError}
              helperText={whatsappDataError.emailsError && "Please enter valid phone number"}
              onChange={(e) => {
                // if(/^[0-9]*$/.test(e.target.value) && e.target.value.length <= 10){
                //   setWhatsappDataError(prev => ({...prev, emailsError: false}))
                //   setWhatsappData(prev => ({...prev, emails: e.target.value}))
                // }
                if(e.target.value !== ""){
                  setWhatsappDataError(prev => ({...prev, emailsError: false}))
                  setWhatsappData(prev => ({...prev, emails: e.target.value}))
                }
              }}
              // InputProps={{
              //   startAdornment: <InputAdornment position="start">+91</InputAdornment>,
              // }}

            /> */}

              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                size="small"
                name="category"
                select
                fullWidth
                error={whatsappDataError.calloutError}
                helperText={
                  whatsappDataError.calloutError &&
                  "Please specify whom this callout is for"
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      Callout for :{" "}
                    </InputAdornment>
                  ),
                }}
                value={whatsappData.category}
                onChange={(event) => {
                  whatsappCalloutMessages.map((callout) => {
                    return setWhatsappData((prevState) => {
                      return callout.callout_type === event.target.value
                        ? { ...prevState, message: callout.message }
                        : prevState;
                    });
                  });
                  setWhatsappDataError((prev) => ({
                    ...prev,
                    calloutError: false,
                  }));
                  setWhatsappDataError((prev) => ({
                    ...prev,
                    messageError: false,
                  }));
                  setWhatsappData((prevState) => {
                    return { ...prevState, category: event.target.value };
                  });
                }}
              >
                <MenuItem value="teachers">Teachers</MenuItem>
                <MenuItem value="students">Students</MenuItem>
              </TextField>

              <Box>
                <Box className="callout-content-tools">
                  <Tooltip title="Clear">
                    <IconButton
                      onClick={() =>
                        setWhatsappData((prevState) => {
                          return { ...prevState, message: "" };
                        })
                      }
                    >
                      <ClearAllIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Copy">
                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(whatsappData.message);
                        dispatch(
                          showSnackbar({
                            message: "Text Copied!",
                            severity: "success",
                          })
                        );
                      }}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  fullWidth
                  placeholder="Type here..."
                  variant="outlined"
                  size="small"
                  color="primary"
                  multiline
                  rows={5}
                  value={whatsappData.message}
                  error={whatsappDataError.messageError}
                  helperText={
                    whatsappDataError.messageError && "Please enter message"
                  }
                  onChange={(event) => {
                    setWhatsappDataError((prev) => ({
                      ...prev,
                      messageError: false,
                    }));
                    setWhatsappData((prevState) => {
                      return { ...prevState, message: event.target.value };
                    });
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      setWhatsappData((prev) => ({
                        ...prev,
                        message: `${e.target.value}\n`,
                      }));
                    }
                  }}
                />
              </Box>
              <Button type="button" onClick={sendCalloutViaWhatsapp}>
                Send
              </Button>
            </Stack>
          )}
        </Box>
      </Modal>
      {unRegisterEmail && (
        <UnRegisterEmails
          open={unRegisterEmail}
          onClose={() => setUnRegisterEmail(false)}
          setSentUnRegisterEmail={setSentUnRegisterEmail}
        />
      )}
    </>
  );
}
